import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BCLoadingAnimation from '@/components/molecules/BCLoadingAnimation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSectionBusyOverlay',
  props: {
  loadingAnimation: {
    type: Number,
    default: 1,
  },
  size: {
    type: Number,
    default: 40,
  },
  bottomOffset: {
    type: Number,
    default: null,
  },
},
  setup(__props) {

const props = __props;



const overlayStyle = computed(() => (
  props.bottomOffset === null ? {} : { paddingBottom: `${props.bottomOffset}px` }
));

return { __sfc: true,props, overlayStyle, BCLoadingAnimation }
}

})